import { createContext } from 'react';
import type { AuthContextType } from './AuthContext';
import type { CreditsContextType } from './CreditsContext';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const CreditsContext = createContext<CreditsContextType | undefined>(undefined);
